import { FormTemplate } from "components/modal/templates";
import { formatDate } from "helpers/date";
import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { editItem } from "sources/books/universalTransferDocuments";
import { config } from "./config";

const hasManualValues = (manualValues) => manualValues !== undefined && manualValues !== null;

class EditUniversalTransferDocumentForm extends FormTemplate {
    close = (data = false) => {
        this.setState({ isLoading: false });
        this.props.back?.(data);
    };

    render = () => this.renderBody();

    sendRequest = () => {
        return editItem({
            id: this.props.data.id,
            comment: this.state.comment,
            documentDate: this.state.documentDate,
            vatRate: this.state.vatRate === "" ? null : this.state.vatRate,
            total: this.state.total,
            ...(hasManualValues(this.state.manualValues) ? { manualValues: this.state.manualValues } : {}),
        });
    };

    renderBodyInner = () => {
        const { documentDate, vatRate, total, comment } = this.props.config;
        return (
            <>
                {this.renderDateField(documentDate)}
                {this.renderField(vatRate)}
                {this.renderField(total)}
                {this.renderField(comment)}
            </>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Сохранить" />;
    };
}

export default function ConfiguredEditUniversalTransferDocumentForm(props) {
    const data = props.data || {};
    const initialState = {
        ...getInitialStateFromConfig(config),
        comment: data.comment || "",
        documentDate: formatDate(data.documentDate || data.primaryUniversalDocument?.date),
        vatRate: data.vatRate || "",
        total: data.total ?? data.totalWithVat ?? data.totalWithoutVat ?? "",
        manualValues: data.manualValues,
    };

    return <EditUniversalTransferDocumentForm {...props} config={config} initialState={initialState} />;
}
